import { Text } from '@joor/design-system'

import { RemindersCellData, RemindersType } from '../joorPayOrders.types'

const getColorForReminderType = (type?: RemindersType) => {
  switch (type) {
    case RemindersType.ALERT:
      return 'error-500'
    case RemindersType.WARNING:
      return 'warning-800'
    default:
      return undefined
  }
}

interface RemindersCellProps {
  value: RemindersCellData
}

export const RemindersCell = ({ value }: RemindersCellProps) => {
  const textColor = getColorForReminderType(value.type)

  return (
    <Text
      fontSize="small"
      fontWeight="medium"
      color={textColor}
      letterSpacing="tighter"
    >
      {value.message}
    </Text>
  )
}
